import * as urlUtils from 'utils/Url';

export function getPathSubscriptions() {
  return `/subscriptions`;
}

export function getPathAddSubscription(product) {
  return `/subscriptions/${product}/add`;
}

export function getPathEditSubscription(subscriptionId) {
  return `/subscriptions/${subscriptionId}/edit`;
}

export function getPathUsages() {
  return `/usages`;
}

export function getPathInvoices(qs={}) {
  return urlUtils.appendQueryString(`/invoices`, qs);
}

export function getPathInvoiceItems(qs={}) {
  return urlUtils.appendQueryString(`/invoice-items`, qs);
}

export function getPathInvoice(invoiceId) {
  return `/invoices/${invoiceId}`;
}

export function getPathCredits(qs={}) {
  return urlUtils.appendQueryString(`/credits`, qs);
}

